import React, { useContext } from 'react';
import LocaleContext from '../../constants/localization';

const GroupForm = ({
  name,
  email,
  responsable,
  description,
  setName,
  setEmail,
  setResponsable,
  setDescription,
  accessToClassifiedInfo,
  setAccessToClassifiedInfo,
  createdFromSSO = false,
  edit = false,
}) => {
  const LS = useContext(LocaleContext);

  return (
    <>
      <label htmlFor="name">{LS.manageGroups.groupName}</label>
      <input
        name="name"
        value={name}
        onChange={(e) => setName(e.target.value)}
        type="text"
        disabled={createdFromSSO}
      />
      <label htmlFor="email">{LS.manageGroups.groupContactEmail}</label>
      <input
        name="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        type="email"
      />
    </>
  );
};

export default GroupForm;
